

const customerName = 'SPASOLUTION';
let initializing = false;

let iframeSrc = null;
let iframeElement = null;
let overlayEl = null;
let closeBtnEl = null;

console.log('Mazing integration v1.4');

const waitForMazingFunctions = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                console.log(`MAZING: Element found: ${selector}`);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                console.warn(`MAZING: Timeout waiting for element: ${selector}`);
                resolve(null);
            }
        }, interval);
    });
};

const slugify = (s) =>
    (s || "")
        .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
        .replace(/ß/g, "ss")
        .replace(/&/g, " and ")
        .toLowerCase()
        .trim()
        .replace(/\([^)]*\)/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replace(/-+/g, "-");

const buildSKU = () => {
    const url = window.location.href;
    const match = url.match(/\/products\/([^?]+)/);
    let handle = match ? match[1] : null;
    if (!handle) return null;

    handle = handle
        .replace(/\/$/, '')
        .replace(/\([^)]*\)/g, '')
        .trim()
        .toLowerCase();

    const checkedRadio = document.querySelector(
        '.block-swatch__radio.product-form__single-selector:checked'
    );

    let selectedValue = '';

    if (checkedRadio) {
        selectedValue = checkedRadio.value;
    } else {
        console.warn('MAZING: No checked swatch found');
        return handle;
    }

    const sku = [handle, slugify(selectedValue)].join('-');
    console.log('MAZING SKU:', sku);
    return sku;
};

async function findProjectAvailable(customer) {
    const sku = buildSKU();
    if (!sku) return { sku: null, projectAvailable: null };

    const projectAvailable = await mazingProjectAvailable({
        customerName: customer,
        getSKU: () => sku
    });

    if (projectAvailable) {
        console.log("MAZING: Matched SKU:", sku);
        return { sku, projectAvailable };
    }

    console.warn("MAZING: No project for SKU:", sku);
    return { sku, projectAvailable: null };
}

function injectOverlayStyles() {
    if (document.getElementById('mzg-overlay-styles')) return;
    const styleEl = document.createElement('style');
    styleEl.id = 'mzg-overlay-styles';
    styleEl.textContent = `
        .mzg-overlay {
          position: absolute;
          inset: 0;
          z-index: 999;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: opacity .22s ease, visibility 0s linear .22s;
        }
        .mzg-overlay.is-open {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
          transition: opacity .22s ease;
        }
        .mzg-overlay__inner {
          position: absolute;
          inset: 0;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 8px 24px rgba(0,0,0,.18);
          overflow: hidden;
          transform: translateY(8px) scale(.985);
          transition: transform .26s ease;
          will-change: transform, opacity;
        }
        .mzg-overlay.is-open .mzg-overlay__inner {
          transform: translateY(0) scale(1);
        }
        @media (prefers-reduced-motion: reduce) {
          .mzg-overlay, .mzg-overlay__inner { transition: none !important; }
        }
    
        .mzg-manual-btn {
          position: absolute;
          bottom: 24px;
          right: 24px;
        
          display: inline-flex;
          align-items: center;
          gap: 10px;
        
          padding: 10px 16px;
          border-radius: 9999px;
        
          background: linear-gradient(
            135deg,
            #4f7cff 0%,
            #1e2d7d 100%
          );
        
          color: #fff;
          font-weight: 600;
          font-size: 14px;
          line-height: 1;
        
          cursor: pointer;
          user-select: none;
        
          box-shadow:
            0 6px 16px rgba(30, 45, 125, 0.35),
            inset 0 1px 0 rgba(255,255,255,0.25);
        
          transition:
            transform .18s ease,
            box-shadow .18s ease,
            opacity .18s ease;
        }
        
        .mzg-manual-btn:hover {
          transform: translateY(-1px);
          box-shadow:
            0 10px 22px rgba(30, 45, 125, 0.45),
            inset 0 1px 0 rgba(255,255,255,0.3);
        }
        
        .mzg-manual-btn:active {
          transform: translateY(0);
          box-shadow:
            0 6px 14px rgba(30, 45, 125, 0.35),
            inset 0 2px 6px rgba(0,0,0,0.15);
        }
        
        .mzg-manual-btn__icon {
          width: 16px;
          height: 16px;
          filter: brightness(0) saturate(100%) invert(100%);
          flex-shrink: 0;
        }
    `;
    document.head.appendChild(styleEl);
}

const showOverlay = () => {
    if (!overlayEl) return;
    if (!iframeElement.src && iframeSrc) iframeElement.src = iframeSrc;
    overlayEl.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => overlayEl.classList.add('is-open'));
};

const hideOverlay = () => {
    if (!overlayEl) return;
    overlayEl.classList.remove('is-open');
    overlayEl.setAttribute('aria-hidden', 'true');
};

async function createOverlayInGallery(galleryContainer) {
    const { sku, projectAvailable } = await findProjectAvailable(customerName);
    console.log("MAZING: project found?", !!projectAvailable, "SKU:", sku);

    if (!projectAvailable) return false;

    iframeSrc = projectAvailable;
    injectOverlayStyles();

    const style = window.getComputedStyle(galleryContainer);
    if (style.position === 'static') galleryContainer.style.position = 'relative';

    overlayEl = document.createElement('div');
    overlayEl.className = 'mzg-overlay';
    overlayEl.setAttribute('aria-hidden', 'true');

    const inner = document.createElement('div');
    inner.className = 'mzg-overlay__inner';

    closeBtnEl = document.createElement('button');
    closeBtnEl.type = 'button';
    closeBtnEl.setAttribute('aria-label', 'Close 3D viewer');
    closeBtnEl.innerHTML = '&times;';
    Object.assign(closeBtnEl.style, {
        position: 'absolute', top: '10px', right: '10px', width: '36px', height: '36px',
        lineHeight: '32px', fontSize: '24px', fontWeight: '700', borderRadius: '9999px',
        background: 'rgba(255,255,255,0.92)', border: '1px solid rgba(0,0,0,.12)',
        cursor: 'pointer', zIndex: '2'
    });

    iframeElement = document.createElement('iframe');
    Object.assign(iframeElement.style, {
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        border: 'none'
    });
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";
    iframeElement.loading = 'eager';

    closeBtnEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideOverlay();
    });

    inner.appendChild(closeBtnEl);
    inner.appendChild(iframeElement);
    overlayEl.appendChild(inner);
    galleryContainer.appendChild(overlayEl);

    return true;
}

function createManualButton({ mountEl, text }) {
    if (!mountEl) return null;

    mountEl.querySelectorAll('.mzg-manual-btn').forEach(el => el.remove());

    const btn = document.createElement('div');
    btn.className = 'mzg-manual-btn sp-montage-info-badge--pulse';
    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.setAttribute('aria-label', text);

    const icon = document.createElement('img');
    icon.className = 'mzg-manual-btn__icon';
    icon.alt = '';
    icon.src = 'https://cdn.mazing.link/assets/svg/3D.svg';

    const span = document.createElement('span');
    span.textContent = text;

    btn.appendChild(icon);
    btn.appendChild(span);

    const open = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showOverlay();
    };

    btn.addEventListener('click', open, true);
    btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') open(e);
    }, true);

    mountEl.appendChild(btn);
    return btn;
}

function getButtonText() {
    const lang = navigator.language || navigator.userLanguage;
    const translations = {
        en: "View in 3D",
        de: "In 3D ansehen",
        fr: "Voir en 3D",
        es: "Ver en 3D"
    };
    return translations[(lang || "en").split("-")[0]] || translations.en;
}

async function refreshMazingForVariantChange() {
    const sku = buildSKU();
    if (!sku) return;

    const newIframeSrc = await mazingProjectAvailable({
        customerName: customerName,
        getSKU: () => sku
    });

    if (newIframeSrc) {
        iframeSrc = newIframeSrc;
        if (iframeElement) iframeElement.src = newIframeSrc;

        try {
            if (typeof mazingRefreshSKU === 'function') {
                await mazingRefreshSKU(sku, customerName);
            }
        } catch (e) {}
    }
}

function bindVariantListeners() {
    document.addEventListener('change', async (e) => {
        if (!e.target.classList.contains('product-form__single-selector')) return;
        await refreshMazingForVariantChange();
    });

    document.addEventListener('change', async (e) => {
        if (!e.target.matches('.block-swatch__radio.product-form__single-selector')) return;
        await refreshMazingForVariantChange();
    });

    document.addEventListener('click', async (e) => {
        const label = e.target.closest('.block-swatch__item');
        if (!label) return;

        setTimeout(() => {
            refreshMazingForVariantChange();
        }, 0);
    });
}

const isMobileViewport = () => window.innerWidth < 1000;

function keepMazingPinnedToFirstGridItem() {
    const grid = document.querySelector('.product-gallery__grid');
    if (!grid) return;

    const move = () => {
        const firstItem = grid.querySelector(':scope > div:first-child');
        if (!firstItem) return;

        const btn = document.querySelector('.mzg-manual-btn');
        const ovl = document.querySelector('.mzg-overlay');
        if (btn && firstItem !== btn.parentElement) firstItem.appendChild(btn);
        if (ovl && firstItem !== ovl.parentElement) firstItem.appendChild(ovl);
    };

    move();

    const mo = new MutationObserver(() => move());
    mo.observe(grid, { childList: true, subtree: false });
}

async function initializeScript() {
    if (initializing) return;
    initializing = true;

    try {
        await waitForMazingFunctions;

        const desktopRootSelector = '.product-gallery__grid';
        const mobileRootSelector  = '.product-gallery__mobile-slider';

        const buttonMountSelectorDesktop = '.product-gallery__grid > div:first-child';
        const buttonMountSelectorMobile  = '.product-gallery__mobile-slider';

        async function getActiveGalleryContainer() {
            const rootSelector = isMobileViewport() ? mobileRootSelector : desktopRootSelector;
            const root = await waitForElement(rootSelector);
            if (!root) return null;

            if (!isMobileViewport()) {
                return root.querySelector(':scope > div:first-child') || root;
            }

            return root;
        }

        const galleryContainer = await getActiveGalleryContainer();
        if (!galleryContainer) {
            console.warn('MAZING: Active gallery container not found');
            return;
        }

        const ok = await createOverlayInGallery(galleryContainer);
        if (!ok) {
            console.log("MAZING: No project available => do not show button.");
            return;
        }

        const mountSelector = isMobileViewport()
            ? buttonMountSelectorMobile
            : buttonMountSelectorDesktop;

        const mountEl = await waitForElement(mountSelector);
        if (mountEl) {
            createManualButton({ mountEl, text: getButtonText() });
        }

        bindVariantListeners();

        if (!isMobileViewport()) {
            keepMazingPinnedToFirstGridItem();
        }

        console.log('MAZING: Initialized successfully (manual button).');
    } catch (error) {
        console.error('MAZING: Initialization failed:', error);
    } finally {
        initializing = false;
    }
}

initializeScript();
